const fragment = `
  id
  name
  imageUrl
  primaryImageUrl
  size
  bedrooms
  bathrooms
  useImageGallery
  longDescription
  hashId
  externalId
  project {
    id
    name
    hashId
    websiteUrl
    packages {
      id
      name
    }
    palettes {
      id
      name
    }
  }
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listBuildingModelsQuery = `
  query ListBuildingModels(
    $filter: BuildingModelFilterInput
  ) {
    items: listBuildingModels(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getBuildingModelQuery = `
  query GetBuildingModels(
    $id: Int!
  ) {
    item: getBuildingModel(id: $id) {
      ${fragment}
    }
  }
`;

export const createBuildingModelQuery = `
  mutation CreateBuildingModel(
    $input: CreateBuildingModelInput!
    $image: Upload
  ) {
    item: createBuildingModel(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateBuildingModelQuery = `
  mutation UpdateBuildingModel(
    $input: UpdateBuildingModelInput!
    $image: Upload
  ) {
    item: updateBuildingModel(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteBuildingModelQuery = `
  mutation DeleteBuildingModel(
    $id: Int!
  ) {
    item: deleteBuildingModel(id: $id) {
      ${fragment}
    }
  }
`;
